import Landscape2D from "./components2D/Landscape2D";
import { useTheme } from "./contexts/ThemeContext";
import { lerp } from "./utils/themeTransition";
import { useState } from "react";
import { Sky, Stars } from "@react-three/drei";
import Lights from "./components/sceneComponents/Lights";
import Character2D from "./components2D/Character2D";
import { EffectComposer, Outline, Selection } from "@react-three/postprocessing";
import { outlineConfig } from "./utils/consts/outlineConfig";
import TextIntro from "./components2D/TextIntro";

// Will make a little low poly outdoor camping scene with all the stuff being clickable :)
const Experience2D = () => {
    const { theme } = useTheme();
    const [transitionProgress, setTransitionProgress] = useState(theme === 'dark' ? 0 : 1);
    
    // Sky configuration for day/night
    const skyConfig = {
        dark: {
            sunPosition: [0, -1, 0],
            inclination: 0,
            azimuth: 0.25,
            mieCoefficient: 0.01,
            mieDirectionalG: 0.8,
            rayleigh: 0.1,
            turbidity: 300
        },
        light: {
            sunPosition: [25, -1, -20],
            inclination: 0,
            azimuth: 0.25,
            mieCoefficient: 0.015,
            mieDirectionalG: 0.1,
            rayleigh: .09,
            turbidity: -0.1
        }
    };

    // Interpolate sky properties
    const currentSkyConfig = {
        sunPosition: [
            lerp(skyConfig.dark.sunPosition[0], skyConfig.light.sunPosition[0], transitionProgress),
            lerp(skyConfig.dark.sunPosition[1], skyConfig.light.sunPosition[1], transitionProgress),
            lerp(skyConfig.dark.sunPosition[2], skyConfig.light.sunPosition[2], transitionProgress)
        ],
        inclination: lerp(skyConfig.dark.inclination, skyConfig.light.inclination, transitionProgress),
        azimuth: lerp(skyConfig.dark.azimuth, skyConfig.light.azimuth, transitionProgress),
        mieCoefficient: lerp(skyConfig.dark.mieCoefficient, skyConfig.light.mieCoefficient, transitionProgress),
        mieDirectionalG: lerp(skyConfig.dark.mieDirectionalG, skyConfig.light.mieDirectionalG, transitionProgress),
        rayleigh: lerp(skyConfig.dark.rayleigh, skyConfig.light.rayleigh, transitionProgress),
        turbidity: lerp(skyConfig.dark.turbidity, skyConfig.light.turbidity, transitionProgress)
    };

    return (
        <>
            {/* Animated sky */}
            <Sky 
                distance={300} 
                sunPosition={currentSkyConfig.sunPosition}
                inclination={currentSkyConfig.inclination}
                azimuth={currentSkyConfig.azimuth}
                mieCoefficient={currentSkyConfig.mieCoefficient}
                mieDirectionalG={currentSkyConfig.mieDirectionalG}
                rayleigh={currentSkyConfig.rayleigh}
                turbidity={currentSkyConfig.turbidity}
            />
            
            {/* Stars - fade out during day */}
            <Stars 
                radius={1} 
                depth={50} 
                count={1000} 
                factor={1.2} 
                saturation={10} 
                fade={true}
                speed={1}
                // Make stars less visible during day
                opacity={1 - transitionProgress * 0.8}
            />

            <Landscape2D />

            <TextIntro />

            <Selection>
                <Character2D />
                <EffectComposer multisampling={8} autoClear={false}>
                    <Outline {...outlineConfig} />
                </EffectComposer>
            </Selection>
            
            <Lights onTransitionProgress={setTransitionProgress} />
        </>
    )
}

export default Experience2D;